import React from 'react';
import profile from '../../images/profile.JPG';
import youtube from '../../images/contacts/youtube.png';
import github from '../../images/contacts/github.png';
import email from '../../images/contacts/email.png';
import linkedin from '../../images/contacts/lin.png';
import medium from '../../images/contacts/medium.svg';
import substack from '../../images/contacts/substack.svg';
import huggingface from '../../images/contacts/huggingface.svg';

import styles from './ContactCard.module.css';

class ContactCard extends React.Component {
    
    render() {
        return (
            <section>
                <img src={profile} id={styles.profileImg} alt="My Headshot"/>
                <h2>Jadesola Bejide</h2>
                <div>Industry Experienced Backend Developer, Aspiring ML Research Scientist</div> 
                <br></br>
                <div><strong>codedbyjade[at]gmail.com</strong></div>
                <span className={styles.contacts}>
                    <a href="http://www.github.com/jade-bejide" target="_blank" rel="noreferrer"><img src={github}  alt="GitHub" /></a>
                    <a href="https://huggingface.co/ephm3ral" target="_blank" rel="noreferrer"><img src={huggingface} alt="HuggingFace" /></a>
                    <a href="http://linkedin.com/in/jadesolabejide" target="_blank" rel="noreferrer" ><img src={linkedin} alt="Connect on LinkedIn"/></a>
                    <a href="https://substack.com/@codedbyjade" target="_blank" rel="noreferrer"><img src={substack} alt="Substack Articles"/></a>
                    <a href="https://medium.com/@jadebejide" target="_blank" rel="noreferrer"><img src={medium} alt="Medium Blog"/></a>

                    {/* <a href="https://www.youtube.com/channel/UClporuWL0lcwiPh5wG-3Xiw" target="_blank" rel="noreferrer"><img src={youtube}  alt="YouTube" /></a> */}
                </span>
            </section>
        )
    }
}

export default ContactCard;